<template>
  <div>
    <Loading v-if="$store.state.modalStore.isLoading" />
    <div class="req-vendor-container">
      <div class="req-vendor-wrapper">
        <div class="req-vendor-header">
          <div class="column100 flex-space-between items-center">
            <div class="req-vendor-header__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13"
                  stroke="#344054"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="req-vendor-header__btn-close cursor-pointer"
              @click.prevent="closeModal"
            >
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>

          <div class="header-info">
            <div class="left-req-vendor">
              <div class="gray900 text-bold text-18">Request Vendor Baru</div>
              <div class="gray600 text-14">
                Tuliskan detail vendor baru untuk pengajuan request
              </div>
            </div>
            <div class="right-req-vendor">
              <div class="gray600 text-14">
                Dokumen Panduan Pengisian Tiket
              </div>
              <button class="btn-download-petunjuk" @click="downloadDoc()">
                Unduh Dokumen Petunjuk
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.125 12.5V13.5C18.125 14.9001 18.125 15.6002 17.8525 16.135C17.6128 16.6054 17.2304 16.9878 16.76 17.2275C16.2252 17.5 15.5251 17.5 14.125 17.5H7.125C5.72487 17.5 5.0248 17.5 4.49002 17.2275C4.01962 16.9878 3.63717 16.6054 3.39748 16.135C3.125 15.6002 3.125 14.9001 3.125 13.5V12.5M14.7917 8.33333L10.625 12.5M10.625 12.5L6.45833 8.33333M10.625 12.5V2.5"
                    stroke="#475467"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="req-vendor-content-wrapper">
          <div class="req-vendor-content text-14">
            <div class="left-req-vendor">
              <div class="column100">
                <label for="">Request ID</label>
                <input
                  type="text"
                  placeholder="Otomatis dari Sistem"
                  disabled
                />
              </div>
              <div class="column100">
                <label for="">Deskripsi <sup>*</sup></label>
                <input
                  type="text"
                  placeholder="Tuliskan Deskripsi Vendor Baru"
                  v-model="changeDesc"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                  maxlength="255"
                />
                <p class="character-count">({{ changeDesc.length }}/255)</p>
              </div>

              <div class="half-form">
                <label for="">Nama Pengadaan</label>
                <input
                  type="text"
                  placeholder="Tuliskan Nama Pengadaan"
                  v-model="pengadaan"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                  maxlength="255"
                />
                <p class="character-count">({{ pengadaan.length }}/255)</p>
              </div>

              <!-- ubah menjadi half form wrapper -->
              <div class="half-form-wrapper">
                <div class="half-form">
                  <label for="">Nama Vendor <sup>*</sup></label>
                  <input
                    type="text"
                    placeholder="Tuliskan Nama Vendor"
                    v-model="setNamaVendor"
                    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                    maxlength="255"
                  />
                  <p class="character-count">
                    ({{ setNamaVendor.length }}/255)
                  </p>
                </div>
                <div class="flex-column half-form">
                  <label for="">Kategori</label>
                  <select v-model="kategori_id" disabled>
                    <option
                      v-for="(option, index) in kategoryList"
                      :key="index"
                      :value="option.id"
                    >
                      {{ option.desc }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="half-form">
                <label for="">PIC Vendor <sup>*</sup></label>
                <input
                  type="text"
                  placeholder="Tuliskan Nama PIC"
                  v-model="picName"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                  maxlength="255"
                />
                <p class="character-count">({{ picName.length }}/255)</p>
              </div>

              <div class="half-form-wrapper">
                <div class="half-form">
                  <label for="">No. Telepon PIC <sup>*</sup></label>
                  <input
                    type="text"
                    v-model="phone"
                    placeholder=" +62 8123xxxx"
                  />
                </div>
                <div>
                  <div class="column100">
                    <label for="">Email Vendor <sup>*</sup></label>
                    <input
                      type="text"
                      v-model="vendorEmail"
                      placeholder="Tuliskan Email Vendor"
                      oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                    />
                  </div>
                </div>
              </div>

              <div class="flex-column column100">
                <label for="">Priority</label>
                <select v-model="priority">
                  <option
                    v-for="(option, index) in priorityList"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.desc }}
                  </option>
                </select>
              </div>
            </div>

            <div class="right-req-vendor">
              <div class="flex-column column100">
                <label for="">Tujuan Pendaftaran</label>
                <select v-model="tujuan_pendaftaran" disabled>
                  <option
                    v-for="(option, index) in tujuan_list"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.desc }}
                  </option>
                </select>
              </div>
              <div class="split-input">
                <div class="flex-column">
                  <label for="">Bidang Usaha</label>
                  <div>
                    <input
                      type="radio"
                      name="bidang-usaha"
                      id="badan_usaha"
                      value="1"
                      v-model="bidang_usaha_id"
                    />
                    <label for="badan_usaha">Badan Usaha</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="bidang-usaha"
                      id="perorangan"
                      value="2"
                      v-model="bidang_usaha_id"
                    />
                    <label for="perorangan">Perorangan</label>
                  </div>
                </div>
                <div class="flex-column">
                  <label for="">Registrasi ke Sistem <sup>*</sup></label>
                  <div class="split-input-two-row">
                    <div>
                      <div>
                        <input
                          type="checkbox"
                          id="ariba"
                          v-model="register_ariba"
                          disabled
                        />
                        <label for="ariba">ARIBA</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="gems"
                          v-model="register_gems"
                        />
                        <label for="gems">SAP GEMS</label>
                      </div>
                    </div>
                    <div>
                      <div>
                        <input
                          type="checkbox"
                          id="bce"
                          v-model="register_bce"
                        />
                        <label for="bce">SAP BERAU</label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          id="bkes"
                          v-model="register_bkes"
                        />
                        <label for="bkes">SAP BKES</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="split-input">
                <div class="flex-column">
                  <label for="">Tipe Pendaftaran Vendor</label>
                  <div class="split-input-two-row">
                    <div>
                      <div class="tooltip-nasional">
                        <input
                          type="radio"
                          name="registrasi"
                          id="nasional"
                          value="1"
                          v-model="type_pendaftaran_id"
                        />
                        <label for="nasional" class="tooltip-label"
                          >Nasional</label
                        >
                        <div class="tooltip-content">
                          PT, PT TBK, YAYASAN, CV, BUMDES, KOPERASI, PERKUMPULAN
                        </div>
                      </div>
                      <div>
                        <input type="radio" name="registrasi" disabled />
                        <label for="">Internasional</label>
                      </div>
                    </div>
                    <div>
                      <div>
                        <input type="radio" name="registrasi" disabled />
                        <label for="">Khusus</label>
                      </div>
                      <div>
                        <input type="radio" name="registrasi" disabled />
                        <label for="">Internal Memo</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>

              <div class="split-input">
                <div>
                  <label for="">Penilaian</label>
                  <div class="split-input">
                    <div style="margin-right: 20px;">
                      <input
                        type="checkbox"
                        v-model="assesment_k3l"
                        id="k3l"
                        disabled
                      />
                      <label for="k3l">K3L</label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        v-model="assesment_kplh"
                        id="kplh"
                        disabled
                      />
                      <label for="kplh">KPLH</label>
                    </div>
                  </div>
                </div>
                <div v-if="assesment_kplh" class="flex-column half-form">
                  <label for="">Pendaftaran Company GEMS</label>
                  <select
                    class="hiw-multiple"
                    v-model="choosed_company"
                    disabled
                  >
                    <option :value="''">Choose Company</option>
                    <option
                      v-for="(list, index) in companies"
                      :value="list.kode"
                      :key="index"
                    >
                      {{ list.nama_perusahaan }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="flex-column column100">
                <label>Dokumen Legalitas</label>
                <label for="file-upload" class="btn-upload-file">
                  {{
                    this.files.length > 0
                      ? this.files[0].name
                      : 'Unggah Dokumen Legalitas'
                  }}
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 12.5V13.5C18 14.9001 18 15.6002 17.7275 16.135C17.4878 16.6054 17.1054 16.9878 16.635 17.2275C16.1002 17.5 15.4001 17.5 14 17.5H7C5.59987 17.5 4.8998 17.5 4.36502 17.2275C3.89462 16.9878 3.51217 16.6054 3.27248 16.135C3 15.6002 3 14.9001 3 13.5V12.5M14.6667 6.66667L10.5 2.5M10.5 2.5L6.33333 6.66667M10.5 2.5V12.5"
                      stroke="#475467"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </label>

                <input
                  id="file-upload"
                  type="file"
                  @change="fileChangeHandler"
                />
              </div>

              <div class="flex-column column100">
                <label for="">Notes</label>
                <textarea
                  rows="4"
                  class="note-area"
                  placeholder="Note ..."
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="button-action-wrapper">
          <div class="button-action">
            <button class="btn-cancel-req-vendor" @click="closeModal">
              Batal
            </button>
            <button class="btn-submit-req-vendor" @click="checkVendorName">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess
      v-if="isModalSuccess"
      :modalText="modalText"
      @closeModalSuccess="closeModalSuccess"
    />
  </div>
</template>
<script>
import axios from 'axios'
export default {
  components: {
    ModalSuccess: () => import('@/components/ModalSuccess.vue'),
    Loading: () => import('@/components/utils/Loading'),
  },

  data() {
    return {
      priorityList: [
        {
          id: 1,
          desc: 'Very High',
        },
        {
          id: 2,
          desc: 'High',
        },
        {
          id: 3,
          desc: 'Medium',
        },
        {
          id: 4,
          desc: 'Low',
        },
        {
          id: 5,
          desc: 'Very Low',
        },
      ],
      kategoryList: [
        {
          id: 1,
          desc: 'CAT - CATEGORY 1',
        },
        {
          id: 2,
          desc: 'GIL - GA,IT & LONG TAILS',
        },
        {
          id: 3,
          desc: 'FEL - FUEL, LUBRICANT & ENERGY',
        },
        {
          id: 4,
          desc: 'MRR - MAINTENANCE & REPAIR, RENTAL',
        },
        {
          id: 5,
          desc: 'CPI - COAL PROCESSING & INFRASTRUCTURE PROJECT',
        },
      ],
      tujuan_list: [
        {
          id: 1,
          desc: 'BIDDING/SOURCING (ARIBA ONLY)',
        },
        {
          id: 2,
          desc: 'PENERBITAN PO DARI PROCUREMENT',
        },
        {
          id: 3,
          desc: 'PENERBITAN PO DARI INTERNAL DEPT',
        },
        {
          id: 4,
          desc: 'PEMBAYARAN BUYER & DEMURRAGE',
        },
        {
          id: 5,
          desc: 'PEMBAYARAN DONASI & CSR',
        },
        {
          id: 5,
          desc: 'PEMBAYARAN DONASI & CSR',
        },
        {
          id: 7,
          desc: 'PENDAFTARAN VENDOR DARI KONTRAKTOR',
        },
      ],

      priority: 5,
      kategori_id: 1,
      tujuan_pendaftaran: 7,

      chooseBu: '',
      chooseTypeRegister: '',
      chooseAssesment: [],
      chooseServer: [],
      files: [],
      memoFiles: [],

      code: '',
      desc: '',
      nama_pengadaan: '',
      nama_vendor: '',
      pic_vendor: '',
      no_telepon: '',
      email_vendor: '',

      //due_date:,
      bidang_usaha_id: 1,
      type_pendaftaran_id: 1,

      register_ariba: true,
      register_bce: true,
      register_gems: false,
      register_bkes: false,

      assesment_k3l: true,
      assesment_kplh: false,

      freeze_ariba: true,
      freeze_gems: true,
      freeze_bkes: true,
      freeze_bce: true,
      freeze_k3l: false,
      freeze_kplh: false,
      note: '',

      vendors: [],
      isOpen: false,

      companies: [],
      choosed_company: '',

      bceChecked: true,
      bkesChecked: false,
      gemsChecked: false,
      k3lChecked: true,
      kplhChecked: false,
      showCompanyGems: false,

      deskripsi: '',
      namaPengadaan: '',
      namaVendor: '',
      picVendor: '',

      isModalSuccess: false,
      modalText:
        'Request vendor baru berhasil diajukan, pengajuan akan segera diproses',
    }
  },
  async created() {
    const gems = await this.$gemsCompanies()

    this.companies = gems
  },
  computed: {
    setNamaVendor: {
      get() {
        return this.nama_vendor
      },
      set(newValue) {
        if (newValue.length > 4) {
          this.getVendor(newValue)
        }
        if (newValue.length == 0) {
          this.isOpen = false
        }
        this.nama_vendor = newValue.toUpperCase()
      },
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
    theFileNameMemo() {
      if (this.memoFiles.length > 0 && 'name' in this.memoFiles[0]) {
        return this.memoFiles[0].name
      }
      return 'Upload Internal Memo'
    },
    changeDesc: {
      get() {
        return this.desc
      },
      set(newValue) {
        this.desc = newValue
      },
    },
    pengadaan: {
      get() {
        return this.nama_pengadaan
      },
      set(newValue) {
        this.nama_pengadaan = newValue
      },
    },
    picName: {
      get() {
        return this.pic_vendor
      },
      set(newValue) {
        this.pic_vendor = newValue
      },
    },
    phone: {
      get() {
        return this.no_telepon
      },
      set(newValue) {
        this.no_telepon = newValue
      },
    },
    changeNote: {
      get() {
        return this.note
      },
      set(newValue) {
        this.note = newValue
      },
    },
    vendorEmail: {
      get() {
        return this.email_vendor
      },
      set(newValue) {
        this.email_vendor = newValue
      },
    },
  },
  watch: {
    register_gems(newValue) {
      if (newValue) {
        this.assesment_kplh = true
      } else {
        this.assesment_kplh = false
      }
    },
    register_bce(newValue) {
      if (newValue) {
        this.assesment_k3l = true
      } else {
        this.assesment_k3l = false
      }
    },
    assesment_kplh(newValue) {
      if (newValue) {
        const filterGoldenCompanyGems = this.companies.filter(
          i => i.nama_perusahaan == 'Golden Energy Mines'
        )

        this.choosed_company = filterGoldenCompanyGems[0].kode
        console.log('choosed company: ', this.companies)
      } else {
        this.choosed_company = ''
      }
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('modalStore/setValue', {
        name: 'modalTicketNewVendor',
        value: false,
      })
    },
    openModalSuccess() {
      console.log('run modal success')
      this.isModalSuccess = true
    },
    closeModalSuccess() {
      this.isModalSuccess = false
      this.$emit('closeReqVendor')
    },
    handleChange() {
      if (this.bceChecked) {
        this.k3lChecked = true
      } else {
        this.k3lChecked = false
      }
      if (this.gemsChecked) {
        this.kplhChecked = true
      } else {
        this.kplhChecked = false
      }
      if (this.kplhChecked) {
        this.showCompanyGems = true
      } else {
        this.showCompanyGems = false
      }
    },

    checkForm(request) {
      console.log('phone: ', this.phone)
      let arr = [
        [request.desc, 'Deskripsi'],
        [request.nama_pengadaan, 'Nama Pengadaan'],
        [request.nama_vendor, 'Nama Vendor'],
        [request.pic_vendor, 'PIC Vendor'],
        [request.no_telepon, 'No. Tlp PIC'],
        [this.isEmailValid(this.email_vendor), 'Email Vendor'],
        [request.tujuan_pendaftaran, 'Tujuan Pendaftaran'],
        [
          request.register_gems ||
            request.register_bce ||
            request.register_bkes ||
            this.register_ariba,
          'Registrasi ke Sistem',
        ],
      ]

      if (request.type_pendaftaran_id == 4) {
        arr = [...arr, [this.memoFiles.length > 0, 'Internal Memo']]
      }

      if (this.assesment_kplh) {
        arr.push([this.choosed_company, 'Pendaftaran Company GEMS'])
      }

      return this.multiConditions(arr)
    },
    checkVendorName() {
      const request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        email_vendor: this.email_vendor,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
        tujuan_pendaftaran: this.tujuan_pendaftaran,
      }

      if (this.assesment_kplh) {
        request.gems_company = this.choosed_company
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }
      if (this.memoFiles && this.memoFiles.length > 0) {
        request['internal_memo'] = this.memoFiles[0]
      }

      const url = `${process.env.VUE_APP_API}/api/v1/vendor-level-1/public?page=1&limit=10&search=${this.nama_vendor}`

      if (this.checkForm(request)) {
        this.$store.commit('modalStore/setValue', {
          name: 'isLoading',
          value: true,
        })
        axios({
          method: 'get',
          url,
        })
          .then(({ data }) => {
            this.$store.commit('modalStore/setValue', {
              name: 'isLoading',
              value: false,
            })

            let searchName = data.data.filter(
              i => i.nama_vendor == this.nama_vendor
            )

            if (searchName.length == 1) {
              if (
                confirm(
                  'Nama Vendor terdeteksi duplikat, apakah Anda yakin untuk melanjutkan pendaftaran Vendor?'
                )
              ) {
                // Save it!
                this.submitRequest(request)
              } else {
                // Do nothing!
              }
            }
          })
          .catch(error => {
            this.$store.commit('modalStore/setValue', {
              name: 'isLoading',
              value: false,
            })
            this.submitRequest(request)
          })
      }
    },
    setResult(value) {
      this.nama_vendor = value
      this.isOpen = false
    },
    async getVendor(search) {
      this.vendors = await this.$autoComplete(search)

      if (this.vendors.length > 0) {
        this.isOpen = true
      } else {
        this.isOpen = false
      }
    },
    resetForm() {
      this.desc = ''
      this.nama_pengadaan = ''
      this.kategori_id = 1
      this.nama_vendor = ''
      this.pic_vendor = ''
      this.no_telepon = ''
      this.priority = 5
      this.bidang_usaha_id = 1
      this.type_pendaftaran_id = 1
      this.register_gems = false
      this.register_bce = false
      this.register_bkes = false
      this.assesment_k3l = false
      this.assesment_kplh = false
      this.note = null
      this.files = []
      this.email_vendor = ''
    },
    showModal() {
      const request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_ariba: this.register_ariba,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }

      if (
        this.desc &&
        this.desc != '' &&
        this.nama_pengadaan &&
        this.nama_pengadaan != '' &&
        this.nama_vendor &&
        this.nama_vendor != '' &&
        this.pic_vendor &&
        this.pic_vendor != '' &&
        this.email_vendor &&
        this.email_vendor != ''
      ) {
        this.$store.commit('modalStore/SET_MODAL_STATE', {
          name: 'dataRequest',
          value: request,
        })
        this.$store.commit('modalStore/SET_MODAL_STATE', {
          name: 'emailRequest',
          value: this.email_vendor,
        })
        this.$store.commit('modalStore/SHOW_NEW_VENDOR_EMAIL')
      } else {
        this.$store.commit('SET_NOTIF', 'Silahkan lengkapi data')
      }
    },
    submitRequest(request) {
      const self = this
      let url = `${process.env.VUE_APP_API}/api/v1/request/vendor`

      this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: true,
      })

      let bodyFormData = new FormData()
      request.dokumen_legalitas &&
        bodyFormData.append('dokumen_legalitas', request.dokumen_legalitas)
      request.tujuan_pendaftaran &&
        bodyFormData.append('tujuan_pendaftaran', request.tujuan_pendaftaran)
      request.internal_memo &&
        bodyFormData.append('internal_memo', request.internal_memo)
      request.email_vendor &&
        request.email_vendor != '' &&
        bodyFormData.append('email_vendor', request.email_vendor)
      bodyFormData.append('desc', request.desc)
      bodyFormData.append('nama_pengadaan', request.nama_pengadaan)
      bodyFormData.append('kategori_id', request.kategori_id)
      bodyFormData.append('nama_vendor', request.nama_vendor)
      bodyFormData.append('pic_vendor', request.pic_vendor)
      bodyFormData.append('priority', request.priority)
      bodyFormData.append('bidang_usaha_id', request.bidang_usaha_id)
      bodyFormData.append('type_pendaftaran_id', request.type_pendaftaran_id)
      bodyFormData.append('register_gems', request.register_gems)
      bodyFormData.append('register_bce', request.register_bce)
      bodyFormData.append('register_bkes', request.register_bkes)
      bodyFormData.append('assesment_k3l', request.assesment_k3l)
      bodyFormData.append('assesment_kplh', request.assesment_kplh)
      bodyFormData.append('note', request.note)
      bodyFormData.append('user_id', self.$store.state.userid)
      bodyFormData.append('type', 1)
      bodyFormData.append('no_telepon', request.no_telepon)

      if (this.assesment_kplh) {
        bodyFormData.append('gems_company', request.gems_company)
      }

      axios({
        method: 'post',
        url,
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(function(response) {
          self.$store.commit('modalStore/setValue', {
            name: 'isLoading',
            value: false,
          })
          self.resetForm()
          self.isModalSuccess = true
        })
        .catch(function(error) {
          console.log('error', error)
          self.$store.commit(
            'SET_NOTIF',
            self.$get(error, 'response.data.message', 'Error')
          )
          self.$store.commit('modalStore/setValue', {
            name: 'isLoading',
            value: false,
          })
        })
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
      console.log('files: ', this.files)
    },
    fileChangeHandlerMemo(e) {
      this.memoFiles = Array.from(e.target.files)
    },
    downloadDoc() {
      const fileName = `Panduan_Landingpage.pdf`
      const fileLocation = `Panduan_Landingpage.pdf`
      if (fileLocation) {
        let linkUrl = `${process.env.VUE_APP_API}/file/${fileLocation}`
        this.$store.commit('setLoading', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(fileName))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('setLoading', false)
          })
          .catch(error => {
            this.$store.commit('setLoading', false)
          })
      }
    },
  },
}
</script>
<style scoped>
input {
  margin-right: 10px;
}
</style>
